import { useLocale } from '@el-plus/hooks/use-locale'
const { t } = useLocale()

export interface NavigationConfig {
  id?: number
  name?: string // 路由name
  title?: string // 标题
  url?: string
  query?: Record<string, string>
}
export const gotoTaskTrace = (workflowId: string) => {
  const item: NavigationConfig = {
    id: Date.now(),
    name: t('ep.bpm.approvalLog'),
    url: `/bpm-pc/#/bpm/trace/taskTrace?pid=&aid=&wid=&tid=${workflowId}`,
  }
  if (window.parent && window.parent.openMenuSelect) {
    window.parent.openMenuSelect(item)
  } else {
    window.open(item.url)
  }
}
